<template>
  <div :class="sidebarClasses"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
      <router-link :to="{name: 'Dashboard'}" tag="a" class="simple-text logo-mini">
          <div class="logo-img">
              <!-- <img v-if="logo" :src="logo"> -->
          </div>
      </router-link>
      <router-link :to="{name: 'Home'}" tag="a" class="simple-text logo-normal">
          {{ ws.getSetting('name') }}
      </router-link>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
      <div class="col-12 text-center sidebar-clock" v-if="localTime">
        At our office, the time is
        <div class="time">
          {{ localTime }}
        </div>
        <span v-if="timezone">{{ timezone }}</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        localTime:'',
        timezone: ''
      }
    },
    props: {
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: '../static/img/vue-logo.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ws: () => { return Webservice; },
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      },
      loadLogo() {
        var logo = Ls.get('opts.logo');
        if(logo) {
          this.logo = logo
        }
      },
      loadTimezone() {
        this.timezone = Webservice.getSetting('timezone');
        if(this.timezone) {
          this.localTime = moment().tz(this.timezone).format('hh:m');

          this.$nextTick(function () {
            window.setInterval(() => {
                this.runTime();
            },1000);
        })
        }
      },
      runTime() {
        this.localTime = moment().tz(this.timezone).format('hh:m');
      }
    },
    mounted () {
      this.initScrollBarAsync();
      this.loadLogo();
      this.loadTimezone();
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue